class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );

    // FIX BUG #3: Track whether cart already had items before this session.
    // We read the cart count from the bubble on page load — if it's > 0,
    // the cart already has items and we should never auto-open the drawer.
    this._cartHadItemsOnLoad = this._getCurrentCartCount() > 0;
  }

  // Read the current visible cart count from the DOM bubble
  _getCurrentCartCount() {
    const bubble = document.querySelector('#cart-icon-bubble .cart-count-bubble [aria-hidden="true"]');
    if (bubble) return parseInt(bubble.textContent.trim(), 10) || 0;
    // If no bubble element exists, cart is empty
    return 0;
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;
    this.getSectionsToRender().forEach((section) => {
      document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });

    if (this.header) this.header.reveal();

    // FIX BUG #3:
    // Only open notification if:
    // 1. Cart was completely empty when the page loaded (no items at all), AND
    // 2. This is the very first item being added (item_count matches first item's quantity), AND
    // 3. The cart drawer isn't already open
    const cartDrawer = document.querySelector('cart-drawer');
    const drawerIsOpen =
      cartDrawer &&
      (cartDrawer.classList.contains('active') ||
        document.body.classList.contains('overflow-hidden'));

    // After sections re-render, check the NEW cart count from parsedState
    const newItemCount = parsedState.item_count;

    // Cart was empty before this add if:
    // - it had no items on page load, AND
    // - new count equals quantity of first unique item (i.e. only 1 unique product in cart now)
    const cartWasEmpty = !this._cartHadItemsOnLoad && parsedState.items.length === 1;

    if (!drawerIsOpen && cartWasEmpty) {
      this.open();
    }

    // Once cart has items, mark it so subsequent adds on this page never re-open
    if (newItemCount > 0) {
      this._cartHadItemsOnLoad = true;
    }
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);